import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { getBranchStatusListApi } from 'features/branchSearch/api/branchSearch';
import type { BranchSearchParams } from 'features/branchSearch/types/BranchSearch.types';

const BRANCH_STATUS_LIST = 'BRANCH_STATUS_LIST';
const BRACN_PAGE_SIZE = 64;

export default function useGetBranchStatusList({ codeRegion, codeType, searchVal }: BranchSearchParams) {
  return useInfiniteQuery({
    queryKey: [BRANCH_STATUS_LIST, { codeRegion }, { codeType }, { searchVal }],
    queryFn: ({ pageParam: page }) =>
      getBranchStatusListApi({
        codeRegion,
        codeType,
        searchVal: searchVal ? searchVal : undefined,
        page,
        size: BRACN_PAGE_SIZE,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (!lastPage.hasNextPage) {
        return null;
      }
      return lastPage.page + 1;
    },
    enabled: !!codeRegion && !!codeType,
    placeholderData: keepPreviousData,
    refetchInterval: 1000 * 10,
  });
}
